<div class="toast-container" role="alert" aria-live="assertive" data-testid="error-toast-section">
  @for (error of errors; track error) {
    <div
      [@slideIn]
      [ngClass]="getToastClass(error)"
      class="toast-item"
      [attr.data-testid]="'error-toast-' + error.id + '-item'"
      [attr.data-teststate]="error.severity">
      <div class="flex items-start gap-3 w-full">
        <!-- Icon -->
        <app-icon [name]="getIcon(error)" size="sm"></app-icon>
        <!-- Content -->
        <div class="flex-1 min-w-0">
          <h4 class="font-semibold text-sm user-text-truncate" [title]="error.title">{{ error.title }}</h4>
          <p class="text-xs opacity-90 mt-1 user-text-clamp-3">{{ error.message }}</p>
          <!-- Timestamp -->
          <p class="text-xs opacity-60 mt-2">
            {{ error.timestamp | date:'short' }}
          </p>
        </div>
        <!-- Actions -->
        <div class="flex items-center gap-1">
          @if (error.retryable) {
            <button
              (click)="dismissError(error.id)"
              class="btn btn-ghost btn-xs"
              title="Retry"
              [attr.data-testid]="'error-toast-' + error.id + '-retry-btn'">
              <app-icon name="refresh" size="xs"></app-icon>
            </button>
          }
          <button (click)="dismissError(error.id)"
            class="btn btn-ghost btn-xs btn-circle"
            title="Dismiss"
            aria-label="Dismiss notification"
            [attr.data-testid]="'error-toast-' + error.id + '-dismiss-btn'">
            <app-icon name="close" size="xs"></app-icon>
          </button>
        </div>
      </div>
    </div>
  }
</div>